import { Spinner } from "../../assets/icon/svg";

interface Props {
    title?: string;
    description?: string;
    color?: string;
    size?: number;
}

export default function LoadingState({
    title = "Loading...",
    description = "Please wait while we retrieve the data.",
    color = "#186cb2",
    size = 24
}: Props) {
    return (
        <div className="flex h-full w-full items-center justify-center px-6">
            <div className="flex flex-col items-center justify-center text-center">
                <div className="flex h-14 w-14 items-center justify-center rounded-full border border-[#186cb2]/20 bg-[#186cb2]/5">
                    <Spinner color={color} size={size} />
                </div>
                <div className="mt-4">
                    <p className="text-sm font-semibold text-gray-800">
                        {title}
                    </p>
                    <p className="mt-0.5 text-xs leading-relaxed text-gray-400">
                        {description}
                    </p>
                </div>
            </div>
        </div>
    );
}